import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientStep, AdminRecipientStepPayload } from '../types'

/** Creates a recipient step under a form version (`POST …/versions/{versionRef}/recipient-steps`). */
export const useCreateAdminRecipientStep = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminRecipientStepPayload, AdminRecipientStep>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/recipient-steps`,
    method: 'POST',
    errorMessage: 'Failed to create the recipient step',
    successMessage: 'Recipient step created',
  })
